import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './Modal.module.scss';
import { useModalStore } from '../../store/ModalStore';

interface ModalProps {
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
  noCross?: boolean;
  disableClose?: boolean; // Новый пропс для блокировки закрытия
}

const Modal: React.FC<ModalProps> = ({
  children,
  open,
  onClose,
  noCross,
  disableClose,
}) => {
  // const open = useModalStore((state) => state.open);
  // const setOpen = useModalStore((state) => state.setOpen);
  // const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const container = document.querySelector('.container') as HTMLElement;
    let prevScroll = 0;
    const preventScroll = (e: TouchEvent) => e.preventDefault();
    if (open && container) {
      prevScroll = container.scrollTop;
      container.style.overflow = 'hidden';
      document.addEventListener('touchmove', preventScroll, { passive: false });
    }
    return () => {
      if (container) {
        container.style.overflow = 'auto';
        container.scrollTop = prevScroll;
      }
      document.removeEventListener('touchmove', preventScroll);
    };
  }, [open]);

  const handleClose = () => {
    // Не закрываем модалку если disableClose = true
    if (disableClose) {
      return;
    }
    onClose();
  };

  if (!open) {
    return null;
  }

  const modalContent = (
    <div
      className={styles.modalWrapper}
      onClick={disableClose ? undefined : handleClose}
    >
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalContent}>
          {!noCross && !disableClose && (
            <button
              className={styles.closeButton}
              onClick={handleClose}
            ></button>
          )}
          {children}
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default Modal;
